var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "control-action"
  }, [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置：")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName"
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 15
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件格式"),
      prop: "fileFormat"
    }
  }, [_c("a-checkbox-group", {
    on: {
      change: function ($event) {
        return _vm.onChangeFormat(_vm.index);
      }
    },
    model: {
      value: _vm.item.fileFormat,
      callback: function ($$v) {
        _vm.$set(_vm.item, "fileFormat", $$v);
      },
      expression: "item.fileFormat"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "xls"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("xls")))]), _c("a-checkbox", {
    attrs: {
      value: "xlsx"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("xlsx")))]), _c("a-checkbox", {
    attrs: {
      value: "docx"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("docx")))]), _c("a-checkbox", {
    attrs: {
      value: "doc"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("doc")))]), _c("a-checkbox", {
    attrs: {
      value: "Word"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Word")))]), _c("a-checkbox", {
    attrs: {
      value: "mov"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("mov")))]), _c("a-checkbox", {
    attrs: {
      value: "mp4"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("mp4")))]), _c("a-checkbox", {
    attrs: {
      value: "rmvb"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("rmvb")))]), _c("a-checkbox", {
    attrs: {
      value: "rm"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("rm")))]), _c("a-checkbox", {
    attrs: {
      value: "avi"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("avi")))]), _c("a-checkbox", {
    attrs: {
      value: "pdf"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("pdf")))]), _c("a-checkbox", {
    attrs: {
      value: "png"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("png")))]), _c("a-checkbox", {
    attrs: {
      value: "jpg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("jpg")))]), _c("a-checkbox", {
    attrs: {
      value: "jpeg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("jpeg")))])], 1)], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件大小"),
      prop: "fileFormat"
    }
  }, [_c("a-input-number", {
    attrs: {
      min: 1,
      max: 1024,
      step: 1,
      formatter: _vm.formatInteger,
      "controls-position": "right"
    },
    model: {
      value: _vm.item.fileSize.size,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileSize, "size", _vm._n($$v));
      },
      expression: "item.fileSize.size"
    }
  }), _c("a-select", {
    staticStyle: {
      width: "80px"
    },
    model: {
      value: _vm.item.fileSize.type,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileSize, "type", $$v);
      },
      expression: "item.fileSize.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "KB"
    }
  }, [_vm._v("KB")]), _c("a-select-option", {
    attrs: {
      value: "MB"
    }
  }, [_vm._v("MB")])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)]), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上传多张")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.fileNumber.is_many,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileNumber, "is_many", $$v);
      },
      expression: "item.fileNumber.is_many"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-input-number", {
    attrs: {
      min: 2,
      max: 10,
      "controls-position": "right",
      disabled: !_vm.item.fileNumber.is_many,
      step: 1,
      formatter: _vm.formatInteger
    },
    on: {
      blur: function ($event) {
        return _vm.handleInputBlur(_vm.item.fileNumber);
      }
    },
    model: {
      value: _vm.item.fileNumber.value,
      callback: function ($$v) {
        _vm.$set(_vm.item.fileNumber, "value", _vm._n($$v));
      },
      expression: "item.fileNumber.value"
    }
  }), _c("a-radio", {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "14px",
      color: "rgba(0, 0, 0, 0.85)"
    }
  }, [_vm._v(_vm._s(_vm.$t("模板：")))]), _c("div", {
    staticClass: "upload-row",
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "margin-left": "50px"
    }
  }, [_c("a-upload", {
    attrs: {
      "list-type": "picture-card",
      action: _vm.action,
      "file-list": _vm.item.fileListData,
      "before-upload": _vm.beforeUpload,
      data: {
        module: "auditAttachment"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.changeUploadTwo,
      preview: _vm.handlePreview
    }
  }, [_c("div", {
    staticClass: "upload-icon"
  }, [_c("div", {
    on: {
      click: function ($event) {
        return _vm.clickPlusTWO(_vm.index);
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(_vm._s(_vm.$t("上传")))])], 1)])])], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {
    staticClass: "nav_50"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClase(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };